import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { get } from "lodash";

function AddCharacter(props) {
  const navigate = useHistory();
  const [formData, setName] = useState({
    CharacterName: "",
    PrefabName: "",
    PrefabURL: "",
  });

  const [CharacterImgPreview, setCharacterImgPreview] = useState("");
  const [CharacterImage, setCharacterImage] = useState();

  const AddCharacterSubmit = async (e) => {
    e.preventDefault();
    let formDataSet = new FormData();
    //formdata object
    if (formData.CharacterName === "" || formData.PrefabName === "" || formData.PrefabURL === "" || !CharacterImage) {
      if (formData.CharacterName === "") {
        Swal.fire({
          title: "Error",
          text: "Character Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.PrefabName === "") {
        Swal.fire({
          title: "Error",
          text: "Character Prefab Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.PrefabURL === "") {
        Swal.fire({
          title: "Error",
          text: "Character Prefab URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (!CharacterImage) {
        Swal.fire({
          title: "Error",
          text: "Character Image is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      formDataSet.append("Character_Name", formData.CharacterName);
      formDataSet.append("Character_Prefab_Name", formData.PrefabName);
      formDataSet.append("Character_URL", formData.PrefabURL);
      formDataSet.append("CharacterImage", CharacterImage);

      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/AddCharacter`,
        data: formDataSet,
        headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.ExpResult) {
            Swal.fire({
              title: "Failed",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
            }).then(function () {
              navigate.push("/CharacterList")
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "An error occured!",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
          Swal.fire({
            title: "Error Occured",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCharacterImgChange = (e) => {
    setCharacterImage(get(e, "target.files[0]"));
    setCharacterImgPreview(URL.createObjectURL(e.target.files[0]));
  }

  /* Function to redirect in Character List Page */
  const BackFunc = () => {
    navigate.push("/CharacterList")
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Add Character</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Add Character</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={AddCharacterSubmit}
                  >

                    {/* Character Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterName}
                          onChange={handleChange}
                          name="CharacterName"
                          className="form-control"
                          id="CharacterName"
                          placeholder="Character Name"
                        />
                      </div>
                    </div>

                    {/* Character Prefab Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PrefabName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Prefab Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PrefabName}
                          onChange={handleChange}
                          name="PrefabName"
                          className="form-control"
                          id="PrefabName"
                          placeholder="Prefab Name"
                        />
                      </div>
                    </div>

                    {/* Character Prefab URL */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PrefabURL"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Prefab URL
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PrefabURL}
                          onChange={handleChange}
                          name="PrefabURL"
                          className="form-control"
                          id="PrefabURL"
                          placeholder="Prefab URL"
                        />
                      </div>
                    </div>

                    {/* Character Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterImg"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Image
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          name="CharacterImg"
                          onChange={handleCharacterImgChange}
                          className="form-control"
                          accept="image/*"
                          style={{ "lineHeight": "1.8" }}
                          id="CharacterImg"
                        />
                      </div>
                    </div>

                    {/* Character Image Preview */}
                    <div className="form-group row">
                      <label
                        className="col-sm-3 control-label"
                      >
                        {" "}
                      </label>
                      <div className="col-sm-9 d-flex justify-content-center">
                        <a href={CharacterImgPreview} target="_blank" rel="noopener">
                          <img
                            src={CharacterImgPreview}
                            style={{
                              width: "150px",
                              maxHeight: "150px",
                              objectFit: "contain",
                            }}
                          />
                        </a>

                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block"
                          style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCharacter;
